import { OptionType } from "bc-front-sagacomponents/lib/src/components/Inputs/Select";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useReduxSelector } from "../../../../hooks/useGetAdherent";
import { getListeAdhesions } from "../../../../redux/AdherentRedux";
import {
  FondCarteWithRef,
  getFondCarte,
  setFondCarte,
} from "../../../../redux/ModeleCarteRedux";
import Api, { IApi } from "../../../../services/Api";
import { AdhesionAdherentParticulierResponse } from "../../../../services/Api/swagger";
import { getApiEndpoint } from "../../../../services/Config";
import { ErrorApi } from "../../../../types";

export const useCarteFidelite = () => {
  //--------------------------- INIT STATE
  // Filtrer adhesions qui ont une ref carte
  const [adhesionsWithRefCarte, setAdhesionsWithRefCarte] = useState<
    AdhesionAdherentParticulierResponse[] | undefined
  >();
  // Tableau des refs cartes trouvées
  const [refCartes, setRefCartes] = useState<
    (number | undefined)[] | undefined
  >();

  // adhésion selectionnée pour afficher le fond de carte de cette adhésion
  const [selectedAdhesion, setSelectedAdhesion] = useState<
    AdhesionAdherentParticulierResponse | undefined
  >();

  // fond de carte sélectionnée de l'adhésion sélectionnée
  const [selectedFondCarte, setSelectedFondCarte] = useState<
    FondCarteWithRef | undefined
  >();
  //--------------------------- INIT STATE

  // récupérer la liste des adhésions
  const listeAdhesions = useReduxSelector((state) => getListeAdhesions(state));

  const dispatch = useDispatch();
  useEffect(() => {
    if (listeAdhesions) {
      // filtrer sur les adhésions qui ont une ref carte
      const adhesionsWithRefCarteState = listeAdhesions.filter(
        (adh) => adh.referenceModeleCarte
      );
      setAdhesionsWithRefCarte(
        listeAdhesions.filter((adh) => adh.referenceModeleCarte)
      );

      // tableau seulement des refs cartes
      const refs: (number | undefined)[] | undefined =
        adhesionsWithRefCarteState &&
        adhesionsWithRefCarteState.map((adh) => adh.referenceModeleCarte);
      // retirer les doublons
      const uniqRefCartes = refs?.filter(
        (ref, index) => refs.indexOf(ref) === index
      );
      // stocker
      setRefCartes(uniqRefCartes);
      dispatch(setFondCarte(undefined));
    } else {
      setRefCartes(undefined);
    }
  }, [listeAdhesions]);

  // récupération dans le store de la liste des fonds de cartes
  const listeFondCarte:
    | FondCarteWithRef[]
    | undefined = useReduxSelector((state) => getFondCarte(state));
  const [errorFondCarte, setFetchingRefCarte] = useState<boolean>(false);
  const [fetchingFondCarte, setErrorRefCarte] = useState<ErrorApi>();
  useEffect(() => {
    if (refCartes && !listeFondCarte) {
      const api: IApi = Api.create(getApiEndpoint() || "http://localhost:8090"); // récupération de l'url de l'api (intégration, recette, production... )
      refCartes.forEach((ref) => {
        setFetchingRefCarte(true);
        ref &&
          api["getFondCarteByModeleCarte"](ref)
            .then((response) => {
              dispatch(
                setFondCarte({ content: response.content, refCarte: ref })
              );
              setFetchingRefCarte(false);
            })
            .catch((error) => {
              setFetchingRefCarte(false);
              setErrorRefCarte(error);
            });
      });
    }
  }, [refCartes]);
  useEffect(() => {
    if (adhesionsWithRefCarte) {
      const defaultSelectedAdhesion = adhesionsWithRefCarte[0];
      setSelectedAdhesion(defaultSelectedAdhesion);
    }
  }, [adhesionsWithRefCarte]);
  useEffect(() => {
    const defaultSelectedFondCarte =
      selectedAdhesion &&
      listeFondCarte?.find(
        (fond) => fond.refCarte === selectedAdhesion.referenceModeleCarte
      );
    setSelectedFondCarte(defaultSelectedFondCarte);
  }, [selectedAdhesion, listeFondCarte]);

  const handleChangeFondCarte = (immat, value) => {
    const findAdhesion =
      adhesionsWithRefCarte &&
      adhesionsWithRefCarte.find((adh) => adh.immatriculation === value);
    const selectedFondCarte = listeFondCarte?.find(
      (fond) =>
        findAdhesion && fond.refCarte === findAdhesion.referenceModeleCarte
    );

    setSelectedAdhesion(findAdhesion);
    setSelectedFondCarte(selectedFondCarte);
  };

  const immatList: OptionType[] | undefined =
    adhesionsWithRefCarte &&
    adhesionsWithRefCarte.map((adh) => {
      return {
        value: adh.immatriculation || " ",
        id: adh.immatriculation || " ",
      };
    });
  return {
    listeFondCarte,
    fetchingFondCarte,
    errorFondCarte,
    selectedAdhesion,
    handleChangeFondCarte,
    selectedFondCarte,
    immatList,
  };
};
